// products modules
import axios from 'axios';
import { CATEGORY_URL, CATEGORY_2_URL, PRODUCT_GREAT_DEALS_URL, PRODUCTS_URL, PRODUCTS_GROUP, PRODUCTS_CATEGORY, GROUP_BUY_URL, WHOLESALE_FETCH_URL,
  PRODUCTS_CATEGORY_DISPLAY, PRODUCTS_GROUP_DISPLAY, } from '../../api/url.js';

// initial state
const state = {
  activeCategory: '', 
  activeCategory2: '',
  activeProduct: '',
  allGroups: [],
  customCategories: [], // api categorie 2
  productDetails: '',
  activeQuantity: 0,
}

// actions
const actions = {
  fetchCategories: ({ commit }, data) => axios({ url: `${CATEGORY_URL}${data}`, method: 'GET' }),
  fetchCustomCategories(context) {
    const config = {
      method: 'get',
      url: CATEGORY_2_URL,
      params: {
        IsListView: true,
        nested: true,
      },
    };
    axios(config) 
    .then((response) => {
      context.commit('fetchCustomCategories', response.data);
    }, (err) => {
      console.log("fetchCustomCategories error:", err);
    })
  },
  fetchProductDetails(context, productNum) {
    const config = {
      method: 'get',
      url: `${PRODUCTS_URL}${productNum}`,
    };
    axios(config) 
    .then((response) => {
      context.commit('fetchProductDetails', response.data);
    }, (err) => {
      console.log("fetchProductDetails error:", err);
    })
  },
  // fetchProductsWithGroupId: ({ commit }, data) => axios({ url: `${PRODUCTS_GROUP}/${data}`, method: 'GET'}),
  fetchProductsWithGroupId: ({ commit }, [data, type]) => {
    // let url = `${PRODUCTS_CATEGORY}/${data}`;
    // if (type === 'group') {
    //   url = `${PRODUCTS_GROUP}/${data}`;
    // }

    let url = `${PRODUCTS_CATEGORY_DISPLAY}/${data}`;
    if (type === 'group') {
      url = `${PRODUCTS_GROUP_DISPLAY}/${data}`;
    }
    return axios({ url: url, method: 'GET'}); 
  },

  fetchProductsWithCategory2Id: ({ commit }, data) => axios({ url: `${CATEGORY_2_URL}${data}`, method: 'GET'}),
  fetchGroupBuyWithId: ({ commit }) => axios({ url: `${GROUP_BUY_URL}`, method: 'GET', params: {page: 1, limit: 99999}}),
  fetchWholesaleWithId: ({ commit }) => axios({ url: `${WHOLESALE_FETCH_URL}`, method: 'GET', params: {page: 1, limit: 99999}}),
};

// mutations
const mutations = {
  fetchCustomCategories(state, payload) {
    state.customCategories = payload
  },
  updateActiveCategory(state, data) {
    state.activeCategory = data
  },
  fetchProductDetails(state, payload) {
    state.productDetails = payload
  },
  updateActiveProduct(state, number) {
    state.activeProduct = number
  },
  updateActiveQuantity(state, payload) {
    state.activeQuantity = payload;
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js